<app-menu>
    <div class="body">
        <div class="p-6 space-y-6">

            <!-- DASHBOARD CARDS -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">

                <!-- Canada FSC -->
                <div class="bg-slate-800 text-white rounded-xl p-5 shadow">
                    <div class="flex items-start justify-between">
                        <div>
                            <h2 class="text-sm uppercase tracking-wide text-slate-400">
                                Canada National FSC
                            </h2>
                        </div>

                        <!-- Status -->
                        <span *ngIf="canada_rate.isCurrent"
                        class="px-2 py-1 rounded-full text-xs font-medium bg-green-500/20 text-green-300"
                        >
                        Current
                        </span>
                        <span *ngIf="!canada_rate.isCurrent"
                        class="px-2 py-1 rounded-full text-xs font-red bg-green-500/20 text-green-300"
                        >
                        Expired
                        </span>
                    </div>

                    <!-- Metrics -->
                    <div class="grid grid-cols-3 gap-3 mt-5">
                        <div class="bg-slate-700/60 rounded-lg p-3">
                            <div class="text-xs uppercase tracking-wise text-slate-400">
                                LTL
                            </div>
                            <div class="text-2xl font-semibold mt-1">
                                {{canada_rate.ltl_rate}}
                            </div>
                        </div>
                        <div class="bg-slate-700/60 rounded-lg p-3">
                            <div class="text-xs uppercase tracking-wise text-slate-400">
                                TL
                            </div>
                            <div class="text-2xl font-semibold mt-1">
                                {{canada_rate.tl_rate}}
                            </div>
                        </div>
                        <div class="bg-slate-700/60 rounded-lg p-3">
                            <div class="text-xs uppercase tracking-wise text-slate-400">
                                Intermodal
                            </div>
                            <div class="text-2xl font-semibold mt-1">
                                {{canada_rate.intermodal_rate}}
                            </div>
                        </div>
                    </div>

                    <div class="mt-4 text-sm text-slate-300">
                        Applicable: {{canada_rate.effectiveStart}} - {{canada_rate.effectiveEnd}}
                    </div>
                </div>

                <!-- US FSC -->
                <div class="bg-slate-800 text-white rounded-xl p-5 shadow">
                    <div class="flex items-start justify-between">
                        <div>
                            <h2 class="text-sm uppercase tracking-wide text-slate-400">
                                US DOT FSC
                            </h2>
                        </div>
                        <!-- Status -->
                        <span *ngIf="us_rate.isCurrent"
                        class="px-2 py-1 rounded-full text-xs font-medium bg-green-500/20 text-green-300"
                        >
                        Current
                        </span>
                        <span *ngIf="!us_rate.isCurrent"
                        class="px-2 py-1 rounded-full text-xs font-red bg-green-500/20 text-green-300"
                        >
                        Expired
                        </span>
                    </div>

                    <!-- Metrics -->
                    <div class="grid grid-cols-3 gap-3 mt-5">
                        <div class="bg-slate-700/60 rounded-lg p-3">
                            <div class="text-xs uppercase tracking-wise text-slate-400">
                                LTL
                            </div>
                            <div class="text-2xl font-semibold mt-1">
                                {{us_rate.ltl_rate}}
                            </div>
                        </div>
                        <div class="bg-slate-700/60 rounded-lg p-3">
                            <div class="text-xs uppercase tracking-wise text-slate-400">
                                TL
                            </div>
                            <div class="text-2xl font-semibold mt-1">
                                {{us_rate.tl_rate}}
                            </div>
                        </div>
                        <div class="bg-slate-700/60 rounded-lg p-3">
                            <div class="text-xs uppercase tracking-wise text-slate-400">
                                Intermodal
                            </div>
                            <div class="text-2xl font-semibold mt-1">
                                {{us_rate.intermodal_rate}}
                            </div>
                        </div>
                    </div>

                    <div class="mt-4 text-sm text-slate-300">
                        Applicable: {{us_rate.effectiveStart}} - {{us_rate.effectiveEnd}}
                    </div>
                </div>

            </div>

            <!-- GRID SECTION -->
            <div class="bg-white rounded-xl shadow border border-slate-200 p-5">

                <div class="flex items-center justify-between mb-6">
                    <div>
                        <h2 class="text-xl font-semibold text-slate-800">
                        FSC Rate Management
                        </h2>
                    </div>
                </div>

                <div class="flex flex-col gap-6">

                    <!-- LEFT GRID -->
                    <div>
                        <div class="mb-2">
                        <h3 class="font-medium text-slate-700">
                            Carrier FSC Rates
                        </h3>
                        </div>

                        <div class="border rounded-lg overflow-hidden h-[300px]">
                            <ag-grid-angular style="height:300px;width:100%" 
                            [rowData]="currentCarriersRowData" 
                            class="ag-theme-ulaap cap-grid" 
                            [columnDefs]="carrierColDefs"></ag-grid-angular>
                        </div>
                    </div>

                    <!-- RIGHT GRID -->
                    <div>
                        <div class="mb-2">
                        <h3 class="font-medium text-slate-700">
                            Customer FSC Rates
                        </h3>
                        </div>

                        <div class="border rounded-lg overflow-hidden h-[300px]">
                            <ag-grid-angular style="height:300px;width:100%" 
                            [rowData]="currentCustomersRowData" 
                            class="ag-theme-ulaap cap-grid" 
                            [columnDefs]="customerColDefs"></ag-grid-angular>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ACCORDION SECTION -->
            <div class="space-y-4">

                <!-- Accordion Item -->
                <div class="bg-white border border-slate-200 rounded-xl shadow-sm">

                    <button class="w-full flex items-center justify-between px-5 py-4 text-left"
                    (click)="isHistoricCarrierAccordionOpen = !isHistoricCarrierAccordionOpen"
                    >
                        <span class="font-medium text-slate-800">
                        Historical Carrier FSC Rates
                        </span>

                        <span class="text-slate-400" [class.rotate-180]="isHistoricCarrierAccordionOpen">
                        ▼
                        </span>
                    </button>

                    <div class="px-5 pb-5 text-sm text-slate-600" *ngIf="isHistoricCarrierAccordionOpen">
                        <ag-grid-angular style="height:300px;width:100%" 
                        [rowData]="historicCarriersRowData" 
                        class="ag-theme-ulaap cap-grid" 
                        [columnDefs]="carrierColDefs"></ag-grid-angular>
                    </div>
                </div>

                <!-- Accordion Item -->
                <div class="bg-white border border-slate-200 rounded-xl shadow-sm">

                    <button
                        class="w-full flex items-center justify-between px-5 py-4 text-left" 
                        (click)="isHistoricCustomerAccordionOpen = !isHistoricCustomerAccordionOpen" 
                    >
                        <span class="font-medium text-slate-800">
                        Historical Customer FSC Rates
                        </span>

                        <span class="text-slate-400" [class.rotate-180]="isHistoricCustomerAccordionOpen">
                        ▼
                        </span>
                    </button>

                    <div class="px-5 pb-5 text-sm text-slate-600" *ngIf="isHistoricCustomerAccordionOpen">
                        <ag-grid-angular style="height:300px;width:100%" 
                        [rowData]="historicCustomersRowData" 
                        class="ag-theme-ulaap cap-grid" 
                        [columnDefs]="customerColDefs"></ag-grid-angular>
                    </div>
                </div>

                <!-- Accordion Item -->
                <div class="bg-white border border-slate-200 rounded-xl shadow-sm">

                    <button
                        class="w-full flex items-center justify-between px-5 py-4 text-left"
                        (click)="isAddRateOpen = !isAddRateOpen"
                    >
                        <span class="font-medium text-slate-800">
                        Update FSC Rates
                        </span>

                        <span class="text-slate-400" [class.rotate-180]="isAddRateOpen">
                        ▼
                        </span>
                    </button>

                    <div class="px-5 pb-5 text-sm text-slate-600" *ngIf="isAddRateOpen">
                        <div *ngIf="fsc_form.hasError('contact_required') && fsc_form.touched">A contact must be selected</div>
                        <div *ngIf="fsc_form.hasError('startDateAfterEndDate') && fsc_form.touched">Start date must be before end date</div>
                        <div *ngIf="fsc_form.hasError('fca_offset_required') && fsc_form.touched">Offsets for LTL and TL must be set</div>
                        <div *ngIf="fsc_form.hasError('fsc_required') && fsc_form.touched">FSC rates for LTL and TL must be set</div>
                        <form [formGroup]="fsc_form" class="flex flex-col gap-4 items-start pt-2" (ngSubmit)="onSubmit()">
                            <div class="grid grid-cols-1 md:grid-cols-[1fr_1fr_1fr_auto] gap-4 items-start">
                                <mat-form-field appearance="outline" class="w-64">
                                    <mat-label>Currency</mat-label>
                                    <mat-select formControlName="currency">
                                        <mat-option value="CAD">CAD</mat-option>
                                        <mat-option value="USD">USD</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="w-64">
                                    <mat-label>Effective Start</mat-label>
                                    <input matInput formControlName="start_date" [matDatepicker]="startpicker">
                                    <mat-datepicker-toggle matIconSuffix [for]="startpicker"></mat-datepicker-toggle>
                                    <mat-datepicker #startpicker></mat-datepicker>
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="w-64">
                                    <mat-label>Effective End</mat-label>
                                    <input matInput formControlName="end_date" [matDatepicker]="endpicker">
                                    <mat-datepicker-toggle matIconSuffix [for]="endpicker"></mat-datepicker-toggle>
                                    <mat-datepicker #endpicker></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="grid grid-cols-1 md:grid-cols-[1fr_2fr_1fr_auto] gap-4 items-start">
                                <mat-form-field appearance="outline" class="w-64">
                                    <mat-label>Contact Type</mat-label>
                                    <mat-select formControlName="contact_type">
                                        <mat-option value="national">National</mat-option>
                                        <mat-option value="carrier">Carrier</mat-option>
                                        <mat-option value="customer">Customer</mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <div
                                    *ngIf="fsc_form.get('contact_type')?.valid
                                        && fsc_form.get('contact_type')?.value != 'national'"
                                    class="w-full block"
                                >
                                    <app-contact-autocomplete
                                        placeholder="Select contact"
                                        [type]="fsc_form.get('contact_type')?.value == 'customer'
                                            ? 'customer_contact_list'
                                            : 'carrier_contact_list'"
                                        (selected)="onContactSelected($event)"
                                        [formControl]="contactFormControl"
                                        class="block"
                                    >
                                    </app-contact-autocomplete>
                                </div>
                                <mat-form-field
                                    *ngIf="fsc_form.get('contact_type')?.valid
                                        && fsc_form.get('contact_type')?.value == 'national'"
                                    appearance="outline"
                                    class="w-full"
                                >
                                    <mat-label>Country</mat-label>
                                    <mat-select formControlName="default_area">
                                        <mat-option value="canada">Canada</mat-option>
                                        <mat-option value="usa">USA</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <div class="w-full pt-1">
                                    <label class="block mb-2 font-medium text-slate-700">
                                        Calculation Method
                                    </label>
                                    <mat-radio-group
                                        formControlName="calculation_method"
                                        class="flex flex-col gap-2"
                                    >
                                        <mat-radio-button value="DIRECT_PERCENT">
                                            Direct FSC Percentage
                                        </mat-radio-button>
                                        <mat-radio-button
                                            *ngIf="fsc_form.get('contact_type')?.value !== 'national'"
                                            value="REFERENCE_OFFSET"
                                        >
                                            Reference Rate Offset
                                        </mat-radio-button>
                                        <mat-radio-button
                                            *ngIf="fsc_form.get('contact_type')?.value !== 'national'"
                                            value="INDEX_SCHEDULE"
                                        >
                                            Fuel Index Schedule
                                        </mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>
                            <div *ngIf="fsc_form.get('contact_type')?.valid && fsc_form.get('calculation_method')?.value === 'DIRECT_PERCENT'" class="grid grid-cols-1 md:grid-cols-[1fr_1fr_1fr_auto] gap-4 items-start">
                                <mat-form-field appearance="outline" class="w-64">
                                    <mat-label>LTL Rate %</mat-label>
                                    <input matInput formControlName="ltl_fsc" type="number">
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="w-64">
                                    <mat-label>TL Rate %</mat-label>
                                    <input matInput formControlName="tl_fsc" type="number">
                                </mat-form-field>
                            </div>
                            <div *ngIf="fsc_form.get('contact_type')?.valid && fsc_form.get('calculation_method')?.value === 'REFERENCE_OFFSET'" class="grid grid-cols-1 md:grid-cols-[1fr_1fr_1fr_auto] gap-4 items-start">
                                <mat-form-field appearance="outline" class="w-64">
                                    <mat-label>Offset Basis</mat-label>
                                    <mat-select formControlName="offset_basis">
                                        <mat-option value="FCA">FCA</mat-option>
                                        <mat-option value="US_DOT">US DOT</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="w-64">
                                    <mat-label>LTL Offset %</mat-label>
                                    <input matInput formControlName="ltl_fca_offset" type="number">
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="w-64">
                                    <mat-label>TL Offset %</mat-label>
                                    <input matInput formControlName="tl_fca_offset" type="number">
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="w-64">
                                    <mat-label>Intermodal Offset %</mat-label>
                                    <input matInput formControlName="intermodal_offset" type="number">
                                </mat-form-field>
                            </div>
                            <!-- Schedule -->
                            <div
                                *ngIf="fsc_form.get('contact_type')?.value !== 'national'
                                    && fsc_form.get('calculation_method')?.value === 'INDEX_SCHEDULE'"
                                class="w-full rounded-2xl border bg-slate-50 p-6 space-y-6"
                            >
                                <!-- Schedule Settings -->
                                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <mat-form-field appearance="outline" class="w-full">
                                        <mat-label>Schedule Basis</mat-label>
                                        <mat-select formControlName="schedule_basis">
                                            <mat-option value="US_DOE">
                                                US DOE Fuel Index
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" class="w-full">
                                        <mat-label>Rate Unit</mat-label>

                                        <mat-select formControlName="schedule_rate_unit">
                                            <mat-option value="PER_MILE">
                                                Per Mile
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <!-- Schedule Brackets -->
                                <div
                                    formArrayName="scheduleBrackets"
                                    class="space-y-4"
                                >
                                    <div
                                        *ngFor="let bracket of scheduleBrackets.controls; let i = index"
                                        [formGroupName]="i"
                                        class="grid grid-cols-1 md:grid-cols-[1fr_1fr_1fr_auto] gap-4 items-start"
                                    >
                                        <mat-form-field appearance="outline" class="w-full">
                                            <mat-label>Min Index</mat-label>
                                            <input
                                                matInput
                                                type="number"
                                                formControlName="min_index"
                                            >
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="w-full">
                                            <mat-label>Max Index</mat-label>
                                            <input
                                                matInput
                                                type="number"
                                                formControlName="max_index"
                                            >
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="w-full">
                                            <mat-label>Rate</mat-label>

                                            <input
                                                matInput
                                                type="number"
                                                formControlName="rate"
                                            >
                                        </mat-form-field>

                                        <button
                                        type="button"
                                        (click)="removeScheduleBracket(i)"
                                        class="h-[56px] w-[56px] rounded-xl border hover:bg-red-50 transition">
                                            <i class="fa-solid fa-trash"></i>
                                        </button>
                                    </div>
                                    <button
                                    type="button"
                                    (click)="addScheduleBracket()"
                                    class="flex items-center gap-2 rounded-xl border px-4 py-2 hover:bg-slate-100 transition">
                                        <i class="fa-solid fa-plus"></i>
                                        Add Bracket
                                    </button>
                                </div>
                            </div>
                            <button
                                type="submit"
                                [disabled]="fsc_form.invalid"
                                class="inline-flex items-center justify-center rounded-2xl bg-blue-600 px-6 py-3 text-sm font-semibold text-white shadow-sm transition-all duration-200 hover:bg-blue-700 hover:shadow-md disabled:cursor-not-allowed disabled:opacity-50"
                            >
                                Save Rate
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="section">
            <h2>Update Charges</h2>
            <form [formGroup]="fsc_form">
                <div style="color:red">
                    <div *ngFor="let error of error_message">{{error}}</div>
                </div>
                <div>
                    <span>Is this rate contact-specific?</span>
                    <mat-button-toggle-group formControlName="is_contact_specific">
                        <mat-button-toggle [value]="true">Yes</mat-button-toggle>
                        <mat-button-toggle [value]="false">No</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
                <div *ngIf="fsc_form.get('rate_type')?.value !== 'FSC'">
                    <span>Is this rate an offset of FCA?</span>
                    <mat-button-toggle-group formControlName="is_fca_offset">
                        <mat-button-toggle [value]="true">Yes</mat-button-toggle>
                        <mat-button-toggle [value]="false">No</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
                <mat-form-field>
                    <mat-label>Rate is for:</mat-label>
                    <mat-select formControlName="rate_type">
                        <mat-option *ngFor="let rate of RATE_TYPES" [value]="rate">{{rate}}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field *ngIf="!fsc_form.get('is_fca_offset')?.value">
                    <mat-label>LTL Fuel Surcharge %</mat-label>
                    <input matInput type="number" formControlName="ltl_fsc">
                </mat-form-field>
                <mat-form-field *ngIf="!fsc_form.get('is_fca_offset')?.value">
                    <mat-label>TL Fuel Surcharge %</mat-label>
                    <input matInput type="number" formControlName="tl_fsc">
                </mat-form-field>
                <mat-form-field *ngIf="fsc_form.get('is_fca_offset')?.value">
                    <mat-label>% Offset from FCA for LTL</mat-label>
                    <input matInput type="number" formControlName="ltl_fca_offset">
                </mat-form-field>
                <mat-form-field *ngIf="fsc_form.get('is_fca_offset')?.value">
                    <mat-label>% Offset from FCA for TL</mat-label>
                    <input matInput type="number" formControlName="tl_fca_offset">
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Start Date</mat-label>
                    <input matInput [matDatepicker]="start_date" formControlName="start_date"/>
                    <mat-datepicker-toggle matIconSuffix [for]="start_date"></mat-datepicker-toggle>
                    <mat-datepicker #start_date>
                    <mat-datepicker-actions>
                        <button mat-button matDatepickerCancel>Cancel</button>
                        <button mat-raised-button color="primary" matDatepickerApply>Confirm</button>
                    </mat-datepicker-actions>              
                    </mat-datepicker>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>End Date</mat-label>
                    <input matInput [matDatepicker]="end_date" formControlName="end_date"/>
                    <mat-datepicker-toggle matIconSuffix [for]="end_date"></mat-datepicker-toggle>
                    <mat-datepicker #end_date>
                    <mat-datepicker-actions>
                        <button mat-button matDatepickerCancel>Cancel</button>
                        <button mat-raised-button color="primary" matDatepickerApply>Confirm</button>
                    </mat-datepicker-actions>              
                    </mat-datepicker>
                </mat-form-field>
                <mat-form-field *ngIf="fsc_form.get('rate_type')?.value !== 'FSC'">
                    <mat-label>Contact</mat-label>
                    <input matInput formControlName="contact_name" [matAutocomplete]="contactAutocomplete">
                </mat-form-field>
                <mat-autocomplete #contactAutocomplete="matAutocomplete" (optionSelected)="onContactSelected($event, 1)">
                    <mat-option *ngFor="let contact of filtered_contact_list" [value]="contact.contact_organization" style="border-bottom: 1px solid grey">
                        <span>{{contact.contact_organization}}</span>
                    </mat-option>
                </mat-autocomplete>
                <button mat-raised-button color="primary" (click)="onSubmit()">Update</button>
            </form>
        </div>
        <div class="section">
            <h2>Find Charge</h2>
            <form [formGroup]='find_rate_form'>
                <mat-form-field>
                    <mat-label>Rate Type</mat-label>
                    <mat-select [(value)]="selected_rate_type">
                        <mat-option *ngFor="let x of RATE_TYPES" [value]="x">{{x}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field *ngIf="selected_rate_type !== 'FSC'">
                    <mat-label>Contact</mat-label>
                    <input matInput formControlName="contact_name" [matAutocomplete]="findContactAutocomplete">
                </mat-form-field>
                <mat-autocomplete #findContactAutocomplete="matAutocomplete" (optionSelected)="onContactSelected($event, 2)">
                    <mat-option *ngFor="let contact of filtered_contact_list" [value]="contact.contact_organization" style="border-bottom: 1px solid grey">
                        <span>{{contact.contact_organization}}</span>
                    </mat-option>
                </mat-autocomplete>
                <button mat-raised-button color="primary" (click)="onSubmitFindCharge()">Find</button>
            </form>
            <form *ngIf="rate_found" [formGroup]="found_rate_form">
                <mat-form-field>
                    <mat-label>Start Date</mat-label>
                    <input matInput readonly formControlName="start">
                </mat-form-field>
                <mat-form-field>
                    <mat-label>End Date</mat-label>
                    <input matInput readonly formControlName="end">
                </mat-form-field>
                <mat-form-field>
                    <mat-label>LTL Rate %</mat-label>
                    <input matInput readonly formControlName="ltl_fsc">
                </mat-form-field>
                <mat-form-field>
                    <mat-label>TL Rate %</mat-label>
                    <input matInput readonly formControlName="tl_fsc">
                </mat-form-field>
                <mat-form-field *ngIf="selected_rate_type !== 'FSC'">
                    <mat-label>LTL FCA Offset %</mat-label>
                    <input matInput readonly formControlName="ltl_fca_offset">
                </mat-form-field>
                <mat-form-field *ngIf="selected_rate_type !== 'FSC'">
                    <mat-label>TL FCA Offset %</mat-label>
                    <input matInput readonly formControlName="tl_fca_offset">
                </mat-form-field>
            </form>
        </div> -->
    </div>
</app-menu>